import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { DownloadProgressProvider } from './contexts/DownloadProgressContext';
import './App.css';
import Dashboard from './pages/Dashboard';
import Accounts from './pages/Accounts';
import Groups from './pages/Groups';
import Analytics from './pages/Analytics';
import Members from './pages/Members';
import Comparison from './pages/Comparison';
import Admin from './pages/Admin';
import CustomGroups from './pages/CustomGroups';
import CreateCustomGroup from './pages/CreateCustomGroup';
import EditCustomGroup from './pages/EditCustomGroup';
import CustomGroupAnalytics from './pages/CustomGroupAnalytics';
import Profile from './pages/Profile';
import Login from './pages/Login';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import Loader from './components/Loader';
import GlobalDownloadProgress from './components/GlobalDownloadProgress';

const AppContent: React.FC = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';

  if (loading) {
    return <Loader fullScreen text="Loading..." />;
  }

  return (
    <div className="App">
      {!isLoginPage && <Navbar />}
      <div className={isLoginPage ? '' : 'container'}>
        <Routes>
          <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute requiredPage="dashboard">
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts"
            element={
              <ProtectedRoute requiredPage="accounts">
                <Accounts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/groups"
            element={
              <ProtectedRoute requiredPage="groups">
                <Groups />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute requiredPage="analytics">
                <Analytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/members"
            element={
              <ProtectedRoute requiredPage="members">
                <Members />
              </ProtectedRoute>
            }
          />
          <Route
            path="/comparison"
            element={
              <ProtectedRoute requiredPage="groups">
                <Comparison />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredPage="admin">
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/custom-groups"
            element={
              <ProtectedRoute requiredPage="admin">
                <CustomGroups />
              </ProtectedRoute>
            }
          />
          <Route
            path="/custom-groups/create"
            element={
              <ProtectedRoute requiredPage="admin">
                <CreateCustomGroup />
              </ProtectedRoute>
            }
          />
          <Route
            path="/custom-groups/:id/edit"
            element={
              <ProtectedRoute requiredPage="admin">
                <EditCustomGroup />
              </ProtectedRoute>
            }
          />
          <Route
            path="/custom-groups/:id/analytics"
            element={
              <ProtectedRoute requiredPage="admin">
                <CustomGroupAnalytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <GlobalDownloadProgress />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <DownloadProgressProvider>
          <AppContent />
        </DownloadProgressProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
